<template>
    <v-card
            :loading="loading"
            :disabled="loading"
    >
        <v-card-title>
            General settings
        </v-card-title>
        <v-card-text>
            <div style="min-height: 400px"></div>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        name: 'OptionsGeneral',
        data(){
            return {
                loading: false,
            }
        }
    }
</script>